import { memo } from "react";
import { Box } from "@mui/material";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import PlannerMyProjectsSection from "./myProjectsSection/PlannerMyProjectsSection";
import PlannerDeadlinesSection from "./myDeadlinesSection/PlannerDeadlinesSection";
import PlannerClassWorkloadSection from "./myWorkloadSection/PlannerClassWorkloadSection";
import PlannerProjectTimelineSection from "./myTimelineSection/PlannerProjectTimelineSection";
import PlannerClassSelectorSection from "../../1_BSZFinderApp/components/sectionCards/klassenAuswahlSection/PlannerClassSelectorSection";
import { useBszPlannerContext } from "../context/bszPlannerContext";
import PlannerProjectTeacherTimelineSection from "./myTimelineSection/PlannerProjectTeacherTimelineSection";

function BSZPlannerMain({ dialogs }) {
  const { isATeacher, isAnAdmin, isTeacherView, isStudentView, isMobile } =
    useAppContext();
  const { selectedClass } = useBszPlannerContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {isATeacher && !isStudentView && <PlannerClassSelectorSection />}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {!isMobile && (
          <Box sx={{ flex: "1 1 400px" }}>
            <PlannerMyProjectsSection />
          </Box>
        )}

        <Box sx={{ flex: "1 1 300px" }}>
          <PlannerDeadlinesSection />
        </Box>
      </Box>

      {selectedClass ? (
        <PlannerProjectTimelineSection dialogs={dialogs} />
      ) : (
        <PlannerProjectTeacherTimelineSection
          dialogs={dialogs}
          type={"teacherOwnProjectView"}
        />
      )}
      {isAnAdmin && !isTeacherView && !isStudentView && selectedClass && (
        <PlannerClassWorkloadSection />
      )}
    </Box>
  );
}

export default memo(BSZPlannerMain);
